<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBWarehouseTypeForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBWarehouseTypeList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBWarehouseTypeForm from './Form.vue'

export default {
  components: {
    EXSBWarehouseTypeForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbwarehousetype/update/isLoading',
      error: 'exsbwarehousetype/update/error',
      deleteError: 'exsbwarehousetype/del/error',
      deleteLoading: 'exsbwarehousetype/del/isLoading',
      created: 'exsbwarehousetype/create/created',
      deleted: 'exsbwarehousetype/del/deleted',
      retrieved: 'exsbwarehousetype/update/retrieved',
      updated: 'exsbwarehousetype/update/updated',
      violations: 'exsbwarehousetype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBWarehouseTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbwarehousetype/create/reset',
      deleteItem: 'exsbwarehousetype/del/del',
      delReset: 'exsbwarehousetype/del/reset',
      retrieve: 'exsbwarehousetype/update/retrieve',
      updateReset: 'exsbwarehousetype/update/reset',
      update: 'exsbwarehousetype/update/update',
      updateRetrieved: 'exsbwarehousetype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbwarehousetype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
